import React, { ReactElement } from "react";

export function CenterInScreen(props: { children: ReactElement }) {
  return <div className="container mx-auto flex flex-col min-h-screen items-center justify-center">
    {props.children}
  </div>;
}
